import { render } from "./firefox.vue?vue&type=template&id=0f4a2a60"
import script from "./firefox.vue?vue&type=script&lang=js"
export * from "./firefox.vue?vue&type=script&lang=js"

import "./firefox.vue?vue&type=style&index=0&id=0f4a2a60&lang=less"

import exportComponent from "/Users/imp/work/credit_chkra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__